module.exports = __webpack_public_path__ + "static/media/Marotte_Chene_aurea_MT2-15-Panel.11735bf2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/Marotte_Chene_aurea_MT2-15-Panel.jpg
// module id = 951
// module chunks = 37